<template>
  <footer class="site-footer">
    <div class="container text-center">
      <router-link to="/">
        <img src="/img/logo.png" alt="Guuu Eats" class="footer-logo">
      </router-link>
      <p class="footer-produced">PRODUCED FOR GUNMA UNIVERSITY</p>
      <p class="footer-link">
        <router-link to="/pages/usage">使い方</router-link>
        <router-link to="/pages/transactionLaw">特定商取引法に基づく表記</router-link>
      </p>
      <p class="footer-copyright">&copy; 2025 Guuu Eats. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SectionFooter',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.site-footer {
  padding: 3rem 0 2rem;
  background-color: $color-text;
  color: #fff;
}

.footer-logo {
  width: 120px;
  margin-bottom: 1rem;
  opacity: 0.9;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
}

.footer-produced {
  font-size: $font-size-small;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-bottom: 1.25rem;
}

.footer-link {
  margin-bottom: 1.25rem;

  a {
    color: rgba(255, 255, 255, 0.7);
    font-size: $font-size-small;
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding-bottom: 2px;
    transition: color 0.2s ease, border-color 0.2s ease;

    &:hover {
      color: #fff;
      border-color: #fff;
    }

    &:not(:last-child) {
      margin-right: 1.5rem;
    }
  }
}

.footer-copyright {
  font-size: $font-size-small;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 0;
}
</style>
